import { t } from 'i18next';
import fiestaLogo from 'src/assets/images/fiesta-logo.png';

export default function JoinTopBarComponent() {
  return (
    <header className="topbar">
      <a className="wordmark" href="#home">
        <img src={fiestaLogo} alt="FIESTA" style={{ height: '44px', width: 'auto' }} />
      </a>
      <nav className="topnav">
        <a href="#how">{t('joinPage.v2.topBar.howItWorks')}</a>
        <a href="#events">{t('joinPage.v2.topBar.events')}</a>
        <a href="#organisers">{t('joinPage.v2.topBar.organisers')}</a>
      </nav>
      <a className="cta" href="#events">{t('joinPage.v2.topBar.findEvent')}</a>
    </header>
  );
}
